<template>
  <div class="animated fadeIn">
      <b-row>
         <b-col sm="12" md="12">
           <b-card class="card-accent-info" header="Parametrage" v-if="mandate.typeoperation_code='PME'">
              <b-button type="button" @click="imprim(paiement_id)" size="sm" variant="success"><i class="fa fa-print"></i> Export statut retrait</b-button>
           </b-card>
            <b-card class="card-accent-info" header="Information sur le payeur">
                <div class="bd-example">
                  <dl class="row">
                      <dt class="col-sm-2">Payeur</dt>
                      <dd class="col-sm-3">{{ mandate.nom }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Téléphone</dt>
                      <dd class="col-sm-3">{{ mandate.telephone }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Adresse</dt>
                      <dd class="col-sm-3">{{ mandate.adresse }}</dd>
                      <dt class="col-sm-1"></dt>
                      
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Nombre de bénéficiaire</dt>
                      <dd class="col-sm-3">{{ mandate.nb_benef }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Code paiement</dt>
                      <dd class="col-sm-3">{{ mandate.groupage }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Motif</dt>
                      <dd class="col-sm-3">{{ mandate.motif }}</dd>
                  </dl>
                </div>
            </b-card>
            <b-card class="card-accent-info" header="Information sur l'opération">
                <div class="bd-example">
                  <dl class="row">
                      <dt class="col-sm-2">Réliquat</dt>
                      <dd class="col-sm-3">{{ mandate.reliquat }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Type opération</dt>
                      <dd class="col-sm-3">{{ mandate.typeoperation_code }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Taux commission</dt>
                      <dd class="col-sm-3">{{ mandate.taux_commission }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Commission</dt>
                      <dd class="col-sm-3">{{ mandate.montant_commission }}</dd>
                      
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Montant TVA</dt>
                      <dd class="col-sm-3">{{ mandate.montant_tva }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Montant TTC</dt>
                      <dd class="col-sm-3">{{ mandate.montant_ttc }}</dd>
                  </dl>
                  <dl class="row">
                      
                      
                      <dt class="col-sm-2">Tarif</dt>
                      <dd class="col-sm-3">{{ mandate.tarif }}</dd>
                  </dl>
                </div>
            </b-card>
            <b-card>
                <div slot="header">
                    <strong>Liste des bénéficiaires</strong>  
                </div>
                <vue-good-table styleClass="vgt-table condensed bordered striped" :row-style-class="rowStyleClassFn" :columns="columns" :rows="mandate.beneficiaires" :fixed-header="false" :pagination-options="pagination" :search-options="search">
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                          <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                            <div role="group" aria-lableledby="header1">                     
                                <router-link :to="'/transferts/update/beneficiare/'+ props.row.id">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button>
                                </router-link>
                                <!--<router-link :to="'/transferts/paiement-masse/retrait/'">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Effectuer un retrait</b-dropdown-item-button>
                                </router-link>  -->    
                            </div>     
                          </b-dropdown>
                        </span>
                        <span v-else style="font-size: 0.875rem;">
                            {{props.formattedRow[props.column.field]}}
                        </span>
                    </template>
                </vue-good-table>
            </b-card>
          </b-col>
      </b-row>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
export default {
  name: 'tables',
   data(){
    return {
      beneficiaires:[],
      beneficiaire:'',
      paiement_id:'',
      mandate:{
            beneficiaires:[],
            adresse: "",
            centre_appel: "",
            date_operation: "",
            deleted_at: "",
            groupage: "",
            guichet_id: "",
            id: "",
            infos_dynamique: "",
            montant_commission: "",
            montant_transfere: "",
            montant_ttc: "",
            montant_tva: "",
            nom: "",
            num_piece: "",
            paiementfile_id: "",
            piece_libelle: "",
            prenom: "",
            reliquat: "",
            tarif: "",
            taux_commission: "",
            taux_tva: "",
            telephone: "",
            motif: "",
            typeoperation_code: "",
            updated_at: "",
            user_id: '',
            nb_benef: '',
            valide: '',
            beneficiaires:[]
      },
      columns: [
        {
          label: 'Nom',
          field: 'nom',
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Prénom(s)',
          field: 'prenom',
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Adresse',
          field: 'adresse',
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Numéro pièce',
          field: 'num_piece',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Type pièce',
          field: 'piece_libelle',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Montant transfere',
          field: 'montant_transfere',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },      
        {
          label: 'Montant TTC',
          field: 'montant_ttc',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },      
        {
          label: 'Tarif',
          field: 'tarif',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Taux commission (%)',
          field: 'taux_commission',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Type opération',
          field: 'typeoperation_code',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        
        {
          label: 'Validé ?',
          field: 'valide',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        }
        // {
        //   label: 'Action',
        //   field: 'btn',
        //   html: true,
        //   width: '150px',
        // }
      ],
      rows: [],
      search:{
          enabled: true,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
      },
      pagination:{
        enabled: true,
        mode: 'records',
        perPage: 10,
        position: 'top',
        perPageDropdown: [3, 10, 100],
        dropdownAllowAll: false,
        setCurrentPage: 2,
        nextLabel: 'Suivant',
        prevLabel: 'Précédent',
        rowsPerPageLabel: 'Ligne par page',
        ofLabel: 'de',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
      }
    }
  },
  methods:{
    formatFn: function (value) {
        return value != null ? value : null
    },
    rowStyleClassFn(row) {
      return row.valide === 1 ? 'valide' : '';
    },
    async imprim(id){
        let response = await this.$store.dispatch('mandate/impression_statut_paiement',id)
        console.log(response)
        window.open(response.content, "_blank")
    },
    async displayOperation(){
        this.paiement_id= this.$route.params.id
        let response = await this.$store.dispatch('mandate/get_paiement_by_id',this.$route.params.id)
            console.log("eeee : ",response)
            this.mandate.adresse=response.adresse,
            this.mandate.centre_appel=response.centre_appel,
            this.mandate.date_operation=response.date_operation,
            this.mandate.deleted_at=response.deleted_at,
            this.mandate.groupage=response.groupage,
            this.mandate.guichet_id=response.guichet_id,
            this.mandate.id=response.id,
            this.mandate.infos_dynamique=response.infos_dynamique,
            this.mandate.montant_commission=response.montant_commission,
            this.mandate.montant_transfere=response.montant_transfere,
            this.mandate.montant_ttc=response.montant_ttc,
            this.mandate.montant_tva=response.montant_tva,
            this.mandate.nom=response.nom,
            this.mandate.num_piece=response.num_piece,
            this.mandate.paiementfile_id=response.paiementfile_id,
            this.mandate.piece_libelle=response.piece_libelle,
            this.mandate.prenom=response.prenom,
            this.mandate.reliquat=response.reliquat,
            this.mandate.tarif=response.tarif,
            this.mandate.taux_commission=response.taux_commission,
            this.mandate.taux_tva=response.taux_tva,
            this.mandate.telephone=response.telephone,
            this.mandate.motif=response.paiementfile.motif,
            this.mandate.nb_benef=response.paiementfile.nb_benef,
            this.mandate.typeoperation_code=response.typeoperation_code,
            this.mandate.updated_at=response.updated_at,
            this.mandate.user_id=response.user_id,
            this.mandate.beneficiaires=response.beneficiaires
            this.mandate.valide=response.valide
            
            this.mandate.beneficiaires.forEach(element => {
                this.beneficiaire = element
                console.log(this.beneficiaire)
                Object.assign(this.beneficiaire,JSON.parse(element.infos_dynamique))
                this.beneficiaires.push(this.beneficiaire)
                for(var key in JSON.parse(element.infos_dynamique)){
                  var found = this.columns.find(function(element1) {
                      return element1.field === key;
                  });
                  if(found == undefined){
                      this.columns.push({
                        label: key,
                        field: key,
                        filterable: true,
                        thClass: 'custom-th-class',
                        filterOptions: {
                          enabled: true, // enable filter for this column
                          placeholder: 'Filter This Thing', // placeholder for filter input
                          filterValue: '', // initial populated value for this filter
                          filterDropdownItems: [], // dropdown (with selected values) instead of text input
                          filterFn: this.columnFilterFn, //custom filter function that
                          trigger: 'keyup', //only trigger on enter not on keyup 
                        }
                    })
                  }
                    
                }
              })

              this.columns.push({
                label: 'Action',
                field: 'btn',
                html: true,
                width: '150px',
              })
            
            //console.log(this.mandate.beneficiaires)
            
        }
    },
    async mounted(){
        await this.displayOperation()
    }
}
</script>
